import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SignIn, SignUp } from '@clerk/clerk-react'; // Removed UserButton, useAuth
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

// Import components
import Header from './components/Header';
import Home from './pages/Home';
import Search from './pages/Search';
import Statistics from './pages/Statistics'; // Import the new page
import UnmatchedBooks from './pages/UnmatchedBooks'; // Import the new page
import ProtectedRoute from './components/ProtectedRoute';

// AppContent no longer needs Clerk state, Header handles it
function AppContent() {
  return (
    <>
      <Header />
      {/* UserButton is now rendered inside Header */}
      <Container maxWidth="lg">
        <Box sx={{ my: 4 }}>
          <Routes>
            {/* Public routes */}
            <Route
              path="/sign-in/*"
              element={<SignIn path="/sign-in" routing="path" signUpUrl="/sign-up" />}
            />
            <Route
              path="/sign-up/*"
              element={<SignUp path="/sign-up" routing="path" signInUrl="/sign-in" />}
            />
            {/* Restore Protected routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />
            <Route
              path="/search"
              element={
                <ProtectedRoute>
                  <Search />
                </ProtectedRoute>
              }
            />
            <Route
              path="/unmatched-books" // Add route for unmatched books page
              element={
                <ProtectedRoute>
                  <UnmatchedBooks />
                </ProtectedRoute>
              }
            />
            <Route
              path="/statistics" // Add route for statistics page
              element={
                <ProtectedRoute>
                  <Statistics />
                </ProtectedRoute>
              }
            />
             {/* Restore catch-all 404 route */}
             <Route path="*" element={<div>Page Not Found</div>} />
          </Routes>
        </Box>
      </Container>
    </>
  );
}

// Create theme (keep this outside the components)
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
    },
  },
});

// Main App component sets up Theme and Router
function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        {/* AppContent now contains the Clerk-dependent logic */}
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;
